// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [

  {
    title: 'Client',
    path: '/dashboard/user',
    icon: icon('ic_user'),
  },
  {
    title: 'Historique',
    path: '/dashboard/products',
    icon: icon('ic_cart'),
  },
  {
    title: 'Invoice Status',
    path: '/dashboard/checkStatus',
    icon: icon('ic_analytics'),
  },
  {
    title: 'Envoi / Recherche',
    path: '/dashboard/sender',
    icon: icon('ic_analytics'),
  },
  {
    title: 'Historique client',
    path: '/dashboard/clientHistory',
    icon: icon('ic_analytics')
  }
];

export default navConfig;
